import styled from 'styled-components';
import MuiInput from '@material-ui/core/Input';
import { fonts, mixins, colors } from '../../../../../css';

const { fontRegular } = fonts;
const { pxToRem } = mixins;
const { colorGrey04 } = colors;

const StyledInput = styled(MuiInput).attrs({ disableUnderline: true })`
  width: 100%;
  margin: 0 5px;
  input {
    font-weight: bold;
    font-size: small;
    padding: 0;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

const Container = styled.div`
  width: 100%;
  padding: ${pxToRem(25)} ${pxToRem(20)};
  border: 1px solid ${colorGrey04};
  margin-top: ${pxToRem(23)};
`;

const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-family: ${fontRegular};

  &:focus {
    outline: none;
  }
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export default { MuiInput: StyledInput, Container, Input };
